import React, { useState } from 'react'
import { Form, Input } from 'antd'
import { AddButtonWarper, AddCommentWrapper } from './style'
import { AddButton } from '../../Category/styles'
import { useAppDispatch } from '../../../utils/hooks/redux';
import { createNoteByAdmin } from '../../../redux/features/activityLog/activityLogAsyncThunk';

export type AddCommentProps = {
    lostId: string | null | undefined;
};

const AddComment = ({ lostId }: AddCommentProps) => {
    const [form] = Form.useForm();
    const dispatch = useAppDispatch();

    const [loading, setLoading] = useState<boolean>(false);

    const onFinish = async (values: any) => {
        try {
            setLoading(true);
            const noteData = {
                lostId,
                ...values,
            };

            await dispatch(createNoteByAdmin(noteData));
            setLoading(false);
            form.resetFields();
        } catch (error) {
            console.log("error:", error)
            setLoading(false);
        }
    };

    return (
        <AddCommentWrapper>
            <Form disabled={loading} form={form} onFinish={onFinish}>
                <Form.Item name="note" rules={[{ required: true, message: "Please enter your comment!" }]}>
                    <Input.TextArea rows={4} placeholder="comment" />
                </Form.Item>
                <AddButtonWarper>
                    <AddButton htmlType="submit" type="primary" loading={loading}>Add comment</AddButton>
                </AddButtonWarper>
            </Form>
        </AddCommentWrapper>
    )
}

export default AddComment
